import { useEffect } from "react"

const BASE_TITLE = "Breakout"

/**
 * Updates the browser tab title.
 *
 * @param title - Page-specific title (will be appended with " - Breakout")
 *                Pass null or undefined to reset to base title
 */
export function useDocumentTitle(title: string | null | undefined) {
	useEffect(() => {
		const previousTitle = document.title
		document.title = title ? `${title} - ${BASE_TITLE}` : BASE_TITLE

		return () => {
			document.title = previousTitle
		}
	}, [title])
}
